module.exports = __webpack_public_path__ + "static/img/shuziyingxiao_09.2153fc31.jpg";